import "../../styles/Various.css"

import React, { useEffect } from "react"
import {
  faChevronLeft,
  faChevronRight,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons"

import EspImg from "./EspImg"
import EsperienzeSearch from "./EsperienzeSearch"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"
import seedEsperienze from "../../data/seedEsperienze"

const Esperienze = ({ esp }) => {
  useEffect(() => {
    document.title = esp.title
  }, [esp.title])

  const findNext = (id) => {
    let i = seedEsperienze.indexOf(id)
    i++
    i = i % seedEsperienze.length
    return seedEsperienze[i]
  }
  const findPrev = (id) => {
    let i = seedEsperienze.indexOf(id)
    if (i === 0) i = seedEsperienze.length
    i--
    return seedEsperienze[i]
  }

  let next = findNext(esp)
  let prev = findPrev(esp)

  const espImgs = esp.imgs.map((img) => (
    <EspImg
      link={img.link}
      path={img.path}
      name={img.name}
      key={img.path.split("/").pop().slice(0, -4)}
      title={esp.title}
    />
  ))

  return (
    <div className="Esp">
      <Helmet>
        <meta
          name="description"
          content="Esperienze di ingegnieria naturalistica e ambientale, energia, ecoturismo, formazione divise in categorie"
        />
      </Helmet>
      <section className="Esp-title">
        <h1 className="pb-5 d-flex flex-wrap">
          <Link to="/esperienze">
            <FontAwesomeIcon icon={faLongArrowAltLeft} className="me-2" />
            Esperienze
          </Link>
          /{esp.title}
        </h1>
        <p className="pt-3">{esp.subtitle}</p>
      </section>

      <section className="mb-4">
        <EsperienzeSearch />
      </section>

      <section className="Esp-img">
        <div className="row">{espImgs}</div>
      </section>
      <section className="Esp-change-page py-4">
        <Link
          className="float-start btn btn-light"
          to={`/esperienze/${prev.id}`}
        >
          <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
          {prev.title}
        </Link>
        <Link className="float-end btn btn-light" to={`/esperienze/${next.id}`}>
          {next.title}
          <FontAwesomeIcon icon={faChevronRight} className="ms-1" />
        </Link>
      </section>
    </div>
  )
}

export default Esperienze
